/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]{height:100%;overflow:hidden}mat-sidenav[_ngcontent-%COMP%]{width:250px}"];
export { styles as styles };
